module.exports = __webpack_public_path__ + "static/don47-023b2a6ade21dafe81948f1c00c79f2b.jpg";